// Infrastruktur- / Werkzeugmodule
import { mediator, timeoutRegistry, eventDebugger } from "./mediator/mediatorInstance.js";
import { registerRefactorHooks } from "./refactor/RefactorHooks";

// Legacy-Bridges
import { TopoLayoutConnector} from './legacy_bridge/TopoLayoutConnector.js';
import { TopoGlobalObjectsConnector } from './legacy_bridge/TopoGlobalObjectsConnector.js';

// Domänenspezifische Logik / Topothek-Module
import { TopoMapCore } from './topoMapCore/TopoMapCore.js';
import { GoogleMapsAdapter } from './topoMapCore/adapter/GoogleMapsAdapter.js';
import { Legacy_TopoMarkers } from './topoMapCore/marker/legacy_TopoMarkers.js';
import { MarkerFactory} from './topoMapCore/factory/MarkerFactory.js';
import { createGroundOverlayLayerClass } from './topoMapCore/overlay/GroundOverlayLayer.js';
import { createQuadOverlayLayerClass } from './topoMapCore/overlay/QuadOverlayLayer.js';
import { createOverlayControlsClass } from './topoMapCore/overlay/OverlayControlsPanel.js';
import { createOverlayPanel } from './topoMapCore/overlay/OverlayPanelController.js';
import { onEscape } from './userInput/escapeKey.js';
import { compactWhenCramped } from './view/compactWhenCramped.js';

// RefactorHooks aktivieren
registerRefactorHooks(mediator);

/**
 * Bootstrap-Factory (Phase 2f): erzeugt Adapter + TopoMapCore-Fassade, sammelt die Config.
 * Die Map selbst wird lazy über facade.bootstrap(initGallery) gestartet.
 */
function createTopoMap(google, { mapOptions, markerFactory, markerClustererLib,
                                 layoutConnector, globalObjectConnector, openGallery }) {
    const mapAdapter = new GoogleMapsAdapter(google);
    mapAdapter.setOverlayClass(google);

    const facade = new TopoMapCore({ mapAdapter, markerFactory, markerClustererLib });
    facade.configure({ mapOptions, layoutConnector, globalObjectConnector, openGallery });
    return facade;
}

// Flat-Overlay-Layer (GroundOverlay) für den Frontend-Anzeigepfad (overlayControls2). google + map zur Laufzeit.
function createGroundOverlayLayer(google, map) {
    const GroundOverlayLayer = createGroundOverlayLayerClass(google);
    return new GroundOverlayLayer(map);
}

// Quad-Overlay-Layer (rotiert/verzerrt) für den Frontend-Anzeigepfad. google + map zur Laufzeit.
function createQuadOverlayLayer(google, map) {
    const QuadOverlayLayer = createQuadOverlayLayerClass(google);
    return new QuadOverlayLayer(map);
}

// Overlay-Steuerung (OV-Button + Panel) für die Frontend-Karten. google + map + opts (side/container) zur Laufzeit.
function createOverlayControls(google, map, opts) {
    const OverlayControlsPanel = createOverlayControlsClass(google);
    return new OverlayControlsPanel(map, opts);
}

window.ModuleJS = {
    TopoMap: TopoMapCore, GoogleMapsAdapter, TopoMarkers: Legacy_TopoMarkers, TopoMarkerFactory: MarkerFactory,
    TopoLayoutConnector, TopoGlobalObjectsConnector, Mediator: mediator,
    createTopoMap, createGroundOverlayLayer, createQuadOverlayLayer, createOverlayControls, createOverlayPanel,
    // Frontend document detail window (index.js): Escape closes it, the close button turns into a × when squeezed.
    onEscape, compactWhenCramped
};